// ============================================================
// NETWORK CONFIGURATION - Change this to switch networks
// ============================================================
// Set to 'mainnet' for production, 'testnet' for testing
const ACTIVE_NETWORK = 'mainnet';
// ============================================================

const NETWORKS = {
  testnet: {
    chainId: '0x15EB',
    chainIdDecimal: 5611,
    chainName: 'opBNB',
    rpcUrls: ['https://opbnb-testnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://testnet.opbnbscan.com'],
    nativeCurrency: { name: 'tBNB', symbol: 'tBNB', decimals: 18 }
  },
  mainnet: {
    chainId: '0xCC',
    chainIdDecimal: 204,
    chainName: 'opBNB',
    rpcUrls: ['https://opbnb-mainnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://opbnbscan.com'],
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 }
  }
};

export const NETWORK = NETWORKS[ACTIVE_NETWORK];
export const EXPLORER_URL = NETWORK.blockExplorerUrls[0];
export default NETWORK;
